import httpManager from "@/app/shared/utils/httpManager";

class FormService {
  /**
   * @param {{ portfolioId: number }} params
   *
   * @returns {Promise<Form[]>}
   */
  async getByPortfolio({ portfolioId }) {
    const url = `/entities/portfolios/${portfolioId}/forms/`;

    const response = await httpManager.get(url);

    return response.data;
  }

  /**
   * @param {number} id
   *
   * @returns {Promise<Form>}
   */
  async getDetails(id) {
    const url = `/forms/${id}/`;

    const response = await httpManager.get(url);

    return response.data;
  }

  /**
   * @param {FormCreateBody} formBody
   *
   * @returns {Promise<Form>}
   */
  async create(formBody) {
    const url = "/forms/";

    const response = await httpManager.post(url, formBody);

    return response.data;
  }

  /**
   * @param {number} id
   * @param {FormElement[]} form
   *
   * @returns {Promise<Form>}
   */

  async edit(id, newFormBody) {
    const url = `/forms/${id}/`;

    const response = await httpManager.put(url, newFormBody);

    return response.data;
  }

  /**
   * @param {number} id
   */
  async delete(id) {
    const url = `/forms/${id}/`;

    await httpManager.delete(url);
  }
}

export const formService = new FormService();
